// Calendario de reservas (ver src/components/BookingDialog.astro)
(function () {
  var dlg = document.getElementById('bk'); if (!dlg || dlg._ready) return; dlg._ready = true;
  var C = JSON.parse(dlg.getAttribute('data-cfg'));
  var grid = document.getElementById('bk-grid'), mon = document.getElementById('bk-month');
  var sum = document.getElementById('bk-sum'), go = document.getElementById('bk-go'), what = document.getElementById('bk-what');
  var today = new Date(); today.setHours(0, 0, 0, 0);
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var iso = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
  // Días ocupados: "06/10/2026", "2026-10-06", "07/10/2026 mañana", "24/12/2026 - 06/01/2027"
  var SLOTS = C.slots.map(function (x) { return x.id; });
  var norm = function (t) { return t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); };
  var busy = {}; // 'aaaa-mm-dd' → true (bloqueado a mano)
  var pd = function (t) {
    var m = t.match(/(\d{4})-(\d{1,2})-(\d{1,2})/); if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
    m = t.match(/(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{2,4})/); if (m) return new Date(+m[3] < 100 ? 2000 + +m[3] : +m[3], +m[2] - 1, +m[1]);
    return null;
  };
  (dlg.getAttribute('data-busy') || '').split(/[\n;]+/).forEach(function (line) {
    line = line.trim(); if (!line) return;
    var parts = line.split(/\s+(?:-|a|al|hasta)\s+/i), a = pd(parts[0]), b = parts[1] ? pd(parts[1]) : a;
    if (!a || !b) return;
    if (/semana/i.test(line)) { // semana entera (lunes a domingo)
      a = new Date(a); a.setDate(a.getDate() - (a.getDay() + 6) % 7);
      b = new Date(b); b.setDate(b.getDate() - (b.getDay() + 6) % 7 + 6);
    }
    for (var d = new Date(a); d <= b; d.setDate(d.getDate() + 1)) busy[iso(d)] = true; // siempre el día entero
  });
  // Días reservables (solo en Shopify): "DD/MM/AAAA|id|1 ó 0;" — 0 = ese día ya tiene una reserva.
  // Cada reserva ocupa el día entero; con C.perWeek días reservados en la misma semana, la semana entera queda ocupada.
  var days = {}, useDays = false;
  (dlg.getAttribute('data-days') || '').split(';').forEach(function (w) {
    var p = w.split('|'); if (p.length < 3) return;
    var m = p[0].match(/(\d{2})\/(\d{2})\/(\d{4})/); if (!m) return;
    days[m[3] + '-' + m[2] + '-' + m[1]] = { id: p[1].trim(), left: +p[2] }; useDays = true;
  });
  var monday = function (d) { var m = new Date(d); m.setDate(m.getDate() - (m.getDay() + 6) % 7); return m; };
  var booked = function (d) { var x = days[iso(d)]; return !!(x && x.left <= 0); };
  var weekFull = function (d) {
    if (!useDays) return false;
    var m = monday(d), n = 0;
    for (var i = 0; i < 7; i++) { if (booked(m)) n++; m.setDate(m.getDate() + 1); }
    return n >= C.perWeek;
  };
  // Festivos (nacionales + Baleares), Semana Santa y puentes
  var hol = {};
  var easter = function (Y) { // algoritmo de Butcher
    var a = Y % 19, b = Math.floor(Y / 100), c = Y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), mo = Math.floor((h + l - 7 * m + 114) / 31);
    return new Date(Y, mo - 1, ((h + l - 7 * m + 114) % 31) + 1);
  };
  var holYear = function (Y) {
    if (hol[Y]) return hol[Y];
    var set = {}, days = [];
    C.holidays.forEach(function (md) { var p = md.split('-'); days.push(new Date(Y, +p[0] - 1, +p[1])); });
    var e = easter(Y);
    (C.easterDays || []).forEach(function (o) { var x = new Date(e); x.setDate(x.getDate() + o); days.push(x); });
    days.forEach(function (x) {
      set[iso(x)] = 1;
      if (C.bridges) { // martes festivo → lunes puente · jueves festivo → viernes puente
        if (x.getDay() === 2) { var y = new Date(x); y.setDate(y.getDate() - 1); set[iso(y)] = 1; }
        if (x.getDay() === 4) { var z = new Date(x); z.setDate(z.getDate() + 1); set[iso(z)] = 1; }
      }
    });
    return (hol[Y] = set);
  };
  var isHoliday = function (d) { return !!holYear(d.getFullYear())[iso(d)]; };
  var first = new Date(today); first.setDate(first.getDate() + C.leadDays);
  var last = new Date(today); last.setDate(last.getDate() + C.maxDays);
  // Estado de cada día: 'off' (gris: finde, festivo o fuera de plazo), 'busy' (rojo: ocupado) u 'ok' (verde)
  var state = function (d) {
    if (d < first || d > last || C.closedWeekdays.indexOf(d.getDay()) >= 0 || isHoliday(d) || (useDays && !days[iso(d)])) return 'off';
    if (busy[iso(d)] || booked(d) || weekFull(d) || C.blocked.indexOf(iso(d)) >= 0) return 'busy';
    return 'ok';
  };
  var ok = function (d) { return state(d) === 'ok'; };
  var firstOk = new Date(first); while (!ok(firstOk) && firstOk <= last) firstOk.setDate(firstOk.getDate() + 1);
  var v0 = firstOk <= last ? firstOk : first;
  var view = new Date(v0.getFullYear(), v0.getMonth(), 1), sel = null, target = null;
  var fmtM = new Intl.DateTimeFormat('es-ES', { month: 'long', year: 'numeric' });
  var fmtD = new Intl.DateTimeFormat('es-ES', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  var cap = function (s) { return s.charAt(0).toUpperCase() + s.slice(1); };
  var slot = function () { var r = dlg.querySelector('input[name="bk-slot"]:checked'); return r ? r.value : ''; };

  function render() {
    mon.textContent = cap(fmtM.format(view));
    grid.innerHTML = '';
    var start = (view.getDay() + 6) % 7; // lunes primero
    for (var i = 0; i < start; i++) grid.appendChild(document.createElement('span'));
    var d = new Date(view);
    while (d.getMonth() === view.getMonth()) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = d.getDate();
      b.className = 'bk-d'; b.setAttribute('data-d', iso(d)); b.setAttribute('aria-label', cap(fmtD.format(d)));
      var st = state(d);
      if (st !== 'ok') { b.disabled = true; b.classList.add(st); b.setAttribute('aria-label', cap(fmtD.format(d)) + (st === 'busy' ? ' · ocupado' : ' · sin servicio')); }
      if (sel && iso(sel) === iso(d)) { b.classList.add('sel'); b.setAttribute('aria-pressed', 'true'); }
      if (iso(d) === iso(today)) b.classList.add('today');
      grid.appendChild(b); d.setDate(d.getDate() + 1);
    }
    document.getElementById('bk-prev').disabled = view <= new Date(first.getFullYear(), first.getMonth(), 1);
    document.getElementById('bk-next').disabled = new Date(view.getFullYear(), view.getMonth() + 1, 1) > last;
  }
  function update() {
    var s = slot();
    sum.textContent = sel ? cap(fmtD.format(sel)) + (s ? ' · ' + s : ' · elige franja') : 'Elige un día en el calendario.';
    sum.classList.toggle('done', !!(sel && s));
    go.disabled = !(sel && s);
  }
  grid.addEventListener('click', function (e) {
    var b = e.target.closest('.bk-d'); if (!b || b.disabled) return;
    var p = b.getAttribute('data-d').split('-'); sel = new Date(+p[0], +p[1] - 1, +p[2]); render(); update();
  });
  dlg.addEventListener('change', update);
  document.getElementById('bk-prev').onclick = function () { view.setMonth(view.getMonth() - 1); render(); };
  document.getElementById('bk-next').onclick = function () { view.setMonth(view.getMonth() + 1); render(); };

  // Abrir desde cualquier botón "Reservar" de un paquete
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-book]'); if (!t) return;
    e.preventDefault(); target = t;
    what.textContent = t.getAttribute('data-book');
    render(); update(); dlg.showModal();
  });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });

  go.onclick = function () {
    if (!sel || !slot() || !target) return;
    var fecha = cap(fmtD.format(sel)), franja = slot();
    var com = (document.getElementById('bk-com').value || '').trim();
    if (C.shop) {
      var f = target.closest('form');
      var put = function (k, v) {
        var i = f.querySelector('input[name="items[0][properties][' + k + ']"]');
        if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = 'items[0][properties][' + k + ']'; f.appendChild(i); }
        i.value = v;
      };
      put('Fecha', fecha); put('Franja', franja);
      var ci = f.querySelector('input[name="items[0][properties][Comentarios]"]');
      if (com) put('Comentarios', com); else if (ci) ci.remove();
      // reservar ese día (producto oculto a 0 €: al comprarse, el día pasa a ocupado)
      var w = useDays && days[iso(sel)];
      f.querySelectorAll('.bk-week').forEach(function (e) { e.remove(); });
      if (w) {
        var n = 0; f.querySelectorAll('input[name^="items["]').forEach(function (e) { var k = +e.name.match(/items\[(\d+)\]/)[1]; if (k >= n) n = k + 1; });
        [['id', w.id], ['quantity', '1']].forEach(function (kv) {
          var i = document.createElement('input'); i.type = 'hidden'; i.className = 'bk-week'; i.name = 'items[' + n + '][' + kv[0] + ']'; i.value = kv[1]; f.appendChild(i);
        });
      }
      go.disabled = true; go.textContent = 'Añadiendo…';
      if (window.gtag) window.gtag('event', 'add_to_cart', { transport_type: 'beacon', item_name: target.getAttribute('data-book') });
      f.submit();
    } else {
      location.href = '/contacto/?reserva=' + encodeURIComponent(target.getAttribute('data-book') + ' · ' + fecha + ' · ' + franja + (com ? '\n\nComentarios: ' + com : ''));
    }
  };
})();
